import React,{useState,useEffect} from "react";
import { useDispatch ,useSelector } from "react-redux";
import { createNewFileListEntryByUser, getAllFileListByUser, manageFileListNamesByUser } from "../../../../store/actions/CreateContent/FolderAPI/ListAPIs";
import { Calendar, Filter, Pencil, Trash2 } from "lucide-react";
import DropDownButtonUI from "../../CreateWebsite/DesignElements/DropDownButtonUI";
import UploaderPagination from "./UploaderPagenation";
import CalendarUploader from "./CalandarUploader";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import bookmark_img from "./img/folder.png"
import LoadingButton from "../../../Loading/LoadingButton";
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";
import AllFilesInListName from "./AllFilesInListName";
import SelectLabelListNameUI from "./SelectLabelListNameUI";

const SetFileInList =({getFileObject,setCloseFileListSelectPopUp,fileObject})=>{
    
        const [active , setActive] = useState({status:false});
  const [deleteItemPopUp, setDeleteItemPopUp] = useState(false);
  const [closeListFilesPopUp, setCloseListFilesPopUp] = useState(false);
            
         
      const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
                     const [isLoaded, setIsLoaded] = useState(false);
                     const [hasError, setHasError] = useState(false);
                     
                        
                             const [reloadItems, setReloadItems] = useState(true);
                            
                                useEffect(()=>{
                                    setReloadItems(false); setReloadItems(true);
                                    
                                },[ ])
                   
                                  
                     return (
                       <div style={{ position: "relative",height:"80px",       
                       width:`${width}px`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
                         {!isLoaded && !hasError && (
                           <div
                            style={
                                { 
                                 borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                                   position: "absolute",
                         top: 0,
                         left: 0,
                         width: `${width}px`,
                         aspectRatio: aspectRatio,
                         objectFit: "cover",  }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                           >
                             <img
                           src={loading_img}
                           alt=""
                         
                          style={
                                {
                                borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                                 borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                                 borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                                 borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                                 
                                   position: "absolute",border:border,
                         top: 0,
                         left: 0,
                         width: `${width}px`,padding:"10px",
                       
                         objectFit: "cover", aspectRatio: aspectRatio,  }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                         />
                           </div>
                         )}
                         
                         <img
                   
                         
                           src={hasError ? fallback_img :bookmark_img}
                           alt=""
                           onLoad={() => setIsLoaded(true)}
                           onError={() => setHasError(true)}
                          style={
                                {
                                   position: "absolute",
                         top: 0,
                         left: 0,
                         width: `${width}px`,
                        
                         objectFit: "cover",aspectRatio: aspectRatio  }}
                        
                         />
                       
                       </div>
                     );
                   }; 
   const App = useSelector((state)=>state?.app?.app);
        const [Courses,setCourses] =useState([])
        const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{},{},{},{},{},{},{},{}])
         const [animate, setAnimate] = useState(false);
         
        const dispatch = useDispatch();  
      
        const currentToken = useSelector((state)=>state?.user?.user?.token);
        const user_email = useSelector((state)=>state?.user?.user?.user_email
       );
       const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
       const appId = useSelector((state)=>state?.app?.app?.ID);
       const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
            
       const [snackbarVisible, setSnackbarVisible] = useState(false);
        
       const [closeQuickViewPopUp, setCloseQuickViewPopUp] = useState(false);
       const [quickViewItem ,setQuickViewItem] =useState({})
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
          const [itemArr, setItemArr] = useState([]);
             const [sort, setSort] = useState("DESC");
          const [pageNo, setPageNo] = useState(1);
        const [startDate, setStartDate] = useState("");
       const [endDate, setEndDate] = useState("");
       const [editType, setEditType] = useState("getAllListsByFileType");
       const [fileType, setFileType] = useState("all");
       const [limit, setLimit] = useState(12);
       const [currentPage, setCurrentPage] = useState(0);
       const [ totalPages, setTotalPages] = useState(0);
   const [ closeCreateListPopUp, setCloseCreateListPopUp] = useState(false);
const [ field, setField] = useState("");
const [ value, setValue] = useState("");


       const [ listEditObject, setListEditObject] = useState({});
const [listName , setListName] =useState("");

       const [ reloadCalendar, setReloadCalendar] = useState(true);
    const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{},{},{},{},{},{},{},{}]);   
        const showSnackbar = () => {
         setSnackbarVisible(true);
       };
       
        const hideSnackbar = () => {
         setSnackbarVisible(false);
       };
     
           const [loader , setLoader] =useState({status:false});
          const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
              {
                
                dispatch({type: "CURSOR",payload:true  });
            
                dispatch({type: "CURSORTEXT",payload:CursorText})
                dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
              }
               
              const handleMouseLeave = () => {
                
                dispatch({type: "CURSOR",payload:false})
            
                dispatch({type: "CURSORTEXT",payload:""})
            
                dispatch({type: "CURSORTEXTBG",payload:""})
                dispatch({type: "CURSORTEXTCOLOR",payload:""})
              
            
            } 
             function convertToYMD(dateStr) {
                
  const [day, month, year] = dateStr?.split("-");
  return `${year}-${month}-${day}`;
}
function formatDate(dateStr) {
  if (!dateStr) return { isoDate: "Invalid", readable: "Invalid date" };

  // Normalize separators (in case it's "27/06/2025" etc.)
  const clean = dateStr.replace(/\//g, "-").trim();

  const parts = clean.split("-");
  if (parts.length !== 3) return { isoDate: "Invalid", readable: "Invalid date" };

  let day, month, year;

  // Detect format:
  // If first part has 4 digits → YYYY-MM-DD
  if (parts[0].length === 4) {
    [year, month, day] = parts;
  } else {
    [day, month, year] = parts;
  }

  // Pad for safety
  day = day.padStart(2, "0");
  month = month.padStart(2, "0");

  const isoDate = `${year}-${month}-${day}`;
  const date = new Date(isoDate);

  if (isNaN(date)) return { isoDate: "Invalid", readable: "Invalid date" };

  // Readable format — e.g. "27 June, 2025"
  const readable = date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  return { isoDate, readable };
}


      
const handlePageChange = (page) => {
    
    setPageNo(page);
  };
  function getTotalPages(total, limit) {
  if (!limit || limit <= 0) return 1; // avoid division by zero
  return Math.ceil(total / limit);
}
useEffect(()=>{
    FireGetAllListsByUser();
    setEditType("getAll")
},[sort,pageNo,startDate,endDate,fileType,limit,editType,])
  
const FireGetAllListsByUser=(e)=>{

     setItemArr([])
     setItemArrLoading([{},{},{},{},{},{},{},{},{},{},{},{}])
    let jsonRequestObject
if(editType=="getAll"){
  jsonRequestObject=  {userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,
  sort:sort,pageNo:pageNo,startDate:startDate,endDate:endDate,limit:limit,

  editType:"getAll"}
}else if(editType=="create"){
  jsonRequestObject=  {userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,
  menu_order:itemArr?.length+1,post_parent:0,visibility:"public",status:"active",fileListName:listName,
  fileListDescription:"Description",

  editType:"create"}
}else if(editType=="updateField"){
  jsonRequestObject=  {userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,
  menu_order:itemArr?.length+1,post_parent:0,visibility:"public",status:"active",value:value,
 field:field,fileListId:listEditObject?.id,

  editType:"updateField"}
}else if(editType=="delete"){
  jsonRequestObject=  {userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,fileListId:listEditObject?.id,

  editType:"delete"}
}


       
setLoader({status:true});
  const apiData = dispatch(manageFileListNamesByUser(jsonRequestObject));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

    //   console.log(response)
      if(response?.lists){setListName("");setField("");setListEditObject({});setField("")
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  setCurrentPage(response?.page)
  setTotalPages(response?.total)
     setItemArr(response?.lists);
     setItemArrLoading([])
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
   
   if(response?.logout){
   
    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  
const ClickCreateNewFileListEntryByUser= (item)=>{

     setItemArr([])
     setItemArrLoading([{},{},{},{},{},{},{},{},{},{},{},{}])
    let jsonRequestObject



       
setLoader({status:true});
  const apiData = dispatch(createNewFileListEntryByUser({userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,postParent:item?.id,
  fileKey:fileObject?.file_s3_key,fileSize:fileObject?.size,mime_type:fileObject?.mime_type,

  editType:""}
));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

    //   console.log(response)
      if(response?.lists){setListName("");setField("");setListEditObject({});setField("")
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  setCurrentPage(response?.page)
  setTotalPages(response?.total)
     setItemArr(response?.lists);
     setItemArrLoading([])
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
   
   if(response?.logout){
   
    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }

  const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 



    return(<>
 <div    onClick={()=>setCloseFileListSelectPopUp(false)} className="ListsV1PopUpSubmitInfoOpacitySubmitInfo"  style={{cursor:"pointer"}}> </div>
        <div   className="ListsV1PopUpSubmitInfo" style={{borderRadius: '0px'}}> 
           <div style={{display:"flex",justifyContent:"space-between",padding:"10px"}}>
            <h2>   <div className="" style={{fontSize:"24px",marginTop:"-13px"}} >Bookmark File Lists </div> </h2>
          <div style={{display:"flex",justifyContent:"space-between",padding:"5px",gap:"10px"}}>
              
 <div  className="calendarOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"rgba(144, 202, 249,1)",}}>
<Calendar size={18} color={"#ffffff"} />
<div className="calendarInner">
    <div style={{position:"absolute",}}>
 {reloadCalendar?<CalendarUploader returnSelectedRange={(v)=>{setStartDate(convertToYMD(v?.from));setEndDate(convertToYMD(v?.to));}} />:""}
     </div>
     </div>
</div>

             <div onClick={()=>{}} className="sortOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"30px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"50px",background:"rgba(144, 202, 249,1)",}}>
<Filter size={18} color={"#ffffff"} />
<div className="sortInner">
 
    <div onClick={()=>{setSort("ASC")}} className="sortInnerItem" style={sort=="ASC"?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>Ascending Order</div>
    <div onClick={()=>{setSort("DESC")}} className="sortInnerItem" style={sort=="DESC"?{background:"rgba(144, 202, 249,1)",color:"#ffffff"}:{background:"#ffffff",color:"rgba(144, 202, 249,1)"}}>Descending Order</div>
    </div>
</div> </div> 
            </div>
     <h5 style={{marginTop:"-25px",padding:"5px"}}>Showing {itemArr?.length} {fileType!=="all"?fileType:""} Bookmark List{itemArr?.length>1?"s":""} in {sort=="ASC"?"Ascending":"Descending"} order 
         {startDate?" from "+formatDate(startDate)?.readable:""} {  startDate!==endDate&&endDate?"to "+formatDate(endDate)?.readable:startDate?"to (select end date)":"" }  {startDate||endDate?<span onClick={()=>{setStartDate("");setEndDate("");setReloadCalendar(false);setTimeout(()=>{setReloadCalendar(true)},100)}} style={{cursor:"pointer",width:"100px",color:"rgba(144, 202, 249,1)"}}> Clear dates</span>:""}
 
     </h5>
 
<div className="PopUpListNameHeight" style={{overflowY:"auto",paddingBottom:"50px"}}>
    
    <div align="center" >
                   <div className="gridFilesShow" >
                    
    {flattenedDataLoading?flattenedDataLoading?.map((item, index) => (
  <div key={index} style={{width:"160px",border:"2px solid #f1f1f1",height:"100px" }}    >
       
            <div
className={""  }
             style={{ margin:"0px",marginTop:"-5px",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div  className="">
                     </div> <div   style={{width:"155px",marginTop:"0px",fontWeight:"999"}}  >
                   <div  className="TitleWithEllipsis" style={{width:"150px",marginTop:"10px",fontWeight:"999"}}  >
                 
                   </div>  </div>  </div>  </div>  </div> )):""} 
     {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.id}  style={{ border:"5px solid #f1f1f1",borderRadius:"10px",padding:"5px",minHeight:"130px",position:"relative"}}  >
         
              <div onClick={()=>{}} style={{display:"flex",justifyContent:"space-between",padding:"5px",cursor:"pointer"}}>
                       
  <ImageFallFB  boxShadow={``}
                      src={""}
                      border={{}}
                      width={ 60
                      }
                      aspectRatio={1/1}
                      borderRadius={ {}
                      }/> <div style={{paddingTop:"25px"}}><div style={{fontSize:"12px",padding:"5px"}}>{item?.total_files} Files </div>
                          <div style={{fontSize:"12px",padding:"5px"}}>{item?.total_size_human} </div>
                          </div></div>
                        <div style={{display:"flex",justifyContent:"space-between",padding:"5px",position:"relative"}}>
                     <div onClick={()=>{}} style={{fontSize:"14px",padding:"5px",cursor:"pointer"}}>{item?.file_list_name} </div>
                         <SelectLabelListNameUI
         getListObject={(v)=>{ClickCreateNewFileListEntryByUser(v) ;setEditType("create");}} item={item} /> </div>
                  
         
                     
 </div>)):"":""}</div></div>
 <h2 style={{display:"flex",justifyContent:"center"}}>{flattenedData?.length==0?"No Files Found":""}</h2>

       <div style={{display:"flex",justifyContent:"center"}}></div>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"10px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
    <button  onClick={()=>{setCloseFileListSelectPopUp(false)}}    className=" ListsSubmitInfoBtn"  type="submit"
 > Cancel </button>
 <div style={{marginTop:"15px",display:"flex",justifyContent:"center",alignItems:"center",gap:"10px",width:"280px"}}>
  <UploaderPagination  currentPage={currentPage}
         totalPages={getTotalPages(totalPages,limit)}
         // totalPages={50}
         onPageChange={handlePageChange} />
        
 </div>
<button onClick={()=>{}}    style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" ListsSubmitInfoBtn"  type="submit"
 > Add File To List </button>
</div> 
</div>



</div>


<style>{`

.PopUpListNameHeight{overflow-y:auto;height:450px;padding:3px;padding-bottom:50px;}

 .ListsSubmitInfoTextbox, .ListsSubmitInfoTextbox:hover, .ListsSubmitInfoTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  
.ListsSubmitInfoBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.ListsColoredTextV1SubmitInfo {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.ListsV1PopUpSubmitInfoOpacitySubmitInfo{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.061);
        z-index:9999999999 !important}
        
        .ListsV1PopUpSubmitInfo{position:fixed;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:0%;bottom:0%;
    padding:15px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
    .ListsV1PopUpSubmitInfo{position:fixed;top:0px;
        left:10%;
        right:10%;top:0%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
  .ListsV1PopUpSubmitInfo{position:fixed;top:0px;
                left:10%;
                right:10%;top:0%;
               }} 

/* xs */
@media (max-width: 767px) {
    
    .ListsV1PopUpSubmitInfo{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }

        /* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .PopUpListNameHeight{height:65vh;}
    }

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
.PopUpListNameHeight{height:65vh;}
  } 

/* xs */
@media (max-width: 767px) {
    .PopUpListNameHeight{height:70vh;}
    
        }
        `}</style>
    </>)
}
export default SetFileInList;